/* angular:styles/component:css;6b18dc3c7a8c728d5acca12fb2abe67868f9f4128ba7541915d8f3aeb873ee1d;/opt/atlassian/pipelines/agent/build/src/app/tab-signals/signal-style-popover.component.ts */
.style-label {
  font-size: 0.8em;
  opacity: 0.8;
  margin-left: 2px;
}
/*# sourceMappingURL=signal-style-popover.component.css.map */
